export default "__VITE_PUBLIC_ASSET__0461107d__"